'use strict';

const slideHiddenClass = 'awards-slide--hidden';
const slideActiveClass = 'awards-slide--active';
const slideSpotlightClass = 'awards-slide--spotlight';
const slideExitClass = 'awards-slide--exit';
const sliderActiveClass = 'awards-slider--active';
const slideClass = 'awards-slide';
const bulletNavActiveClass = 'awards-slider-nav__bullet--active';
class AwardsSlider {

    // duplicate slides
    duplicateSlides(slide) {

        let slideCopy = slide.cloneNode(true);
        slideCopy.setAttribute('data-slide', 'copy');
        slideCopy.classList.add(slideHiddenClass);
        slideCopy.classList.remove(slideActiveClass);
        slide.parentNode.appendChild(slideCopy);

    }

    // go to slide
    goToSlide(slide, current) {
 
        current.classList.add(slideExitClass);
        setTimeout(() => {
            current.classList.remove(slideExitClass);
        }, 300);

        this.hideAllSlides(slide);
        this.showSlide(slide);
        this.activateBullet(slide);
        
    }

    // hide all slides
    hideAllSlides(slide) {
                
        const allSlides = slide.parentNode.querySelectorAll(`.${slideClass}`);
        allSlides.forEach(slide => {
            slide.classList.remove(slideActiveClass);
            slide.classList.remove(slideSpotlightClass);
            slide.classList.add(slideHiddenClass);
        });

    }

    // activate bullet
    activateBullet(slide) {

        const bulletsWrapper = slide.parentNode.nextElementSibling;
        const slideNumber = slide.getAttribute('data-slide-num');

        // if theres a bullet nav
        if (bulletsWrapper.classList.contains('awards-slider-nav')) {
            
            const bullets = bulletsWrapper.querySelectorAll('.awards-slider-nav__bullet');

            // remove active class from each bullet
            bullets.forEach(bullet => {
                bullet.classList.remove(bulletNavActiveClass);
            });

            // add active class to active bullet
            bulletsWrapper.querySelector(`[data-slide-bullet="${slideNumber}"`).classList.add(bulletNavActiveClass);
        }

    }

     // show slide
     showSlide(slide) {

        // remove hidden classes
        slide.classList.remove(slideHiddenClass);
         if (slide.nextElementSibling !== null) {
             slide.nextElementSibling.classList.remove(slideHiddenClass);
             if (slide.nextElementSibling.nextElementSibling !== null) {
                 slide.nextElementSibling.nextElementSibling.classList.remove(slideHiddenClass);
             }
         }

        // add spotlight class
        slide.classList.add(slideSpotlightClass);

        // add active classes
        slide.classList.add(slideActiveClass);
        if (slide.nextElementSibling !== null) {
            slide.nextElementSibling.classList.add(slideActiveClass);
            if (slide.nextElementSibling.nextElementSibling !== null) {
                slide.nextElementSibling.nextElementSibling.classList.add(slideActiveClass);
            }
        }


    }

    constructor() {

       const awardsSliders = document.querySelectorAll('.awards-slider');
       const self = this;
       
       
       if (awardsSliders) {
           
            //  for each slider
            awardsSliders.forEach(slider => {
                
                const sliderSpeed = slider.getAttribute('data-aw-speed');
                const allSlides = slider.querySelectorAll(`.${slideClass}`);
                const awardsSliderNav = document.querySelector('.awards-slider-nav');
                
                // init
                slider.classList.add(sliderActiveClass);
                this.hideAllSlides(allSlides[0]);
                this.showSlide(allSlides[0]);
                
                // duplicate first two slides for stacking effect
                this.duplicateSlides(allSlides[0]); 
                this.duplicateSlides(allSlides[1]);

                // highlight first slide
                allSlides[0].classList.add(slideSpotlightClass);

                // add event listeners to the bullet buttons
                if (awardsSliderNav) {

                    const bullets = awardsSliderNav.querySelectorAll('[data-slide-bullet]');
                    
                    // activate first bullet
                    bullets[0].classList.add(bulletNavActiveClass);

                    // for each bullet
                    bullets.forEach(bullet => {
                        
                        let targetNumber = bullet.getAttribute('data-slide-bullet');
                        targetNumber = targetNumber - 1;
                        
                        // add a click handler to the button
                        bullet.querySelector('button').addEventListener('click', (e) => {
                            e.preventDefault();
                            clearInterval(sliderInterval);
                            const currentSlide = slider.querySelector(`.${slideSpotlightClass}`);
                            this.goToSlide(allSlides[targetNumber], currentSlide)
                        })
                        
                    });
                }
                

                // autoplay
                const sliderInterval = setInterval(() => {

                    const currentSlide = slider.querySelector(`.${slideSpotlightClass}`);
                    let target = currentSlide.nextElementSibling;

                    // if the next slide is a copy, go to slide 1
                    if (target.getAttribute('data-slide') == 'copy') {
                        target = allSlides[0];
                    }

                    this.goToSlide(target, currentSlide);

                }, sliderSpeed);


                
            });

       }
       
    }


}

module.exports = AwardsSlider;
